// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__3ui7L","card_news":"style_card_news__2smDk","view":"style_view__1HrUC","card_body":"style_card_body__EqFkI","DeployedHospital":"style_DeployedHospital__37B2R"};